import { Box } from '@mui/material'
import React from 'react'
import styles from "../index.module.css";
import RateClassTable from './rateClassTable';
import DeclineDetailsTable from './declineDetailsTable';
import ApplicationProgressTable from './applicationProgressTable';
import LnidDeclineTable from './lnidDeclineTable';
import { ThreePsCodeTable } from '../../../Pages/insights/components/analysisDetails/threePsTable/threePsCodeTable.index';
import { TotalCodesIndicator } from '../../../Pages/insights/components/analysisDetails/threePsTable/components/threePsSection/components/totalCodesIndicator/totalCodesIndicator.index';

interface IAutomatedNoteSectionProps {
    title: string;
    tableData: any
}

const AutomatedNoteSection = (props: IAutomatedNoteSectionProps) => {

    const { title, tableData } = props

    const renderExtraElement = () => {
        if (title === '3Ps Code Details') {
            return <TotalCodesIndicator tableData={tableData} />;
        }
        return null;
    }

    const renderTable = () => {
        switch (title) {
            case 'Rate Class Details':
                return <RateClassTable tableData={tableData} />;
            case 'Decline Details':
            case 'RTU Question Details':
                return <DeclineDetailsTable tableData={tableData} />;
            case 'Application Progress Details':
                return <ApplicationProgressTable tableData={tableData} />;
            case 'Lnid Decline Details':
                return <LnidDeclineTable tableData={tableData} />;
            case '3Ps Code Details':
                return <ThreePsCodeTable tableData={tableData} />;
            default:
                return null;
        }
    };

    return (
        <Box className={styles.questionsOuter}>
            <Box className={styles.automatedNoteSection}>
                <Box className={styles.automatedNoteSectionHeader}>
                    <p className={styles.noteHeader}>{title}</p>
                    {renderExtraElement()}
                </Box>
                {renderTable()}
            </Box>
        </Box>
    )
}

export default AutomatedNoteSection